<template lang="pug">
.rooms-schedules-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :filter="filter"
    :filter-included-fields="filterFields"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // ヘッダートップ
    // ライブラリに列を描画させると列結合等レイアウト&デザインが意図通りに出来ないので自作の列を作成する
    // ライブラリが描画する列はスタイルで非表示にしている
    template(#thead-top="data")
      b-tr.day-line
        b-th.room-name(rowspan="2")
          span 部屋名
        b-th.room-type(rowspan="2")
          span 種別
          br
          span （人数）
        b-th(v-for="day in getDayFields(data)" :key="day.key + '-' + useType" :id="day.key + '-' + useType" colspan="2")
          span {{ day.datetime }}（
          span(:class="getWeekClass(day)") {{ day.week }}
          span ）
          b-popover(v-if="day.holidayName" :target="day.key + '-' + useType" triggers="hover")
            span {{ day.holidayName }}
      b-tr.ampm-line
        b-th.day(v-for="day in getDays(data)" :key="day.key") {{ day.label }}

    // セル：部屋名
    template(#cell(name)="row")
      .name.text {{ row.item.name }}
    // セル：種別（人数）
    template(#cell(type)="row")
      .type.text {{ getRoomTypeName(row.item) }}{{ getCapacity(row.item) }}
    // セル：1日 ※以降のセルはfieldsにkeyNameがなければ表示されないので31日分用意している
    template(#cell(day1am)="row")
      .residents(:id="'day1am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 0)") {{ resident.residentName }}
      b-popover(:target="'day1am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 0)") {{ resident.residentName }}
    template(#cell(day1pm)="row")
      .residents(:id="'day1pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 1)") {{ resident.residentName }}
      b-popover(:target="'day1pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 1)") {{ resident.residentName }}
    // セル：2日
    template(#cell(day2am)="row")
      .residents(:id="'day2am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 2)") {{ resident.residentName }}
      b-popover(:target="'day2am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 2)") {{ resident.residentName }}
    template(#cell(day2pm)="row")
      .residents(:id="'day2pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 3)") {{ resident.residentName }}
      b-popover(:target="'day2pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 3)") {{ resident.residentName }}
    // セル：3日
    template(#cell(day3am)="row")
      .residents(:id="'day3am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 4)") {{ resident.residentName }}
      b-popover(:target="'day3am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 4)") {{ resident.residentName }}
    template(#cell(day3pm)="row")
      .residents(:id="'day3pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 5)") {{ resident.residentName }}
      b-popover(:target="'day3pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 5)") {{ resident.residentName }}
    // セル：4日
    template(#cell(day4am)="row")
      .residents(:id="'day4am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 6)") {{ resident.residentName }}
      b-popover(:target="'day4am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 6)") {{ resident.residentName }}
    template(#cell(day4pm)="row")
      .residents(:id="'day4pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 7)") {{ resident.residentName }}
      b-popover(:target="'day4pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 7)") {{ resident.residentName }}
    // セル：5日
    template(#cell(day5am)="row")
      .residents(:id="'day5am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 8)") {{ resident.residentName }}
      b-popover(:target="'day5am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 8)") {{ resident.residentName }}
    template(#cell(day5pm)="row")
      .residents(:id="'day5pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 9)") {{ resident.residentName }}
      b-popover(:target="'day5pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 9)") {{ resident.residentName }}
    // セル：6日
    template(#cell(day6am)="row")
      .residents(:id="'day6am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 10)") {{ resident.residentName }}
      b-popover(:target="'day6am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 10)") {{ resident.residentName }}
    template(#cell(day6pm)="row")
      .residents(:id="'day6pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 11)") {{ resident.residentName }}
      b-popover(:target="'day6pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 11)") {{ resident.residentName }}
    // セル：7日
    template(#cell(day7am)="row")
      .residents(:id="'day7am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 12)") {{ resident.residentName }}
      b-popover(:target="'day7am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 12)") {{ resident.residentName }}
    template(#cell(day7pm)="row")
      .residents(:id="'day7pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 13)") {{ resident.residentName }}
      b-popover(:target="'day7pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 13)") {{ resident.residentName }}
    // セル：8日
    template(#cell(day8am)="row")
      .residents(:id="'day8am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 14)") {{ resident.residentName }}
      b-popover(:target="'day8am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 14)") {{ resident.residentName }}
    template(#cell(day8pm)="row")
      .residents(:id="'day8pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 15)") {{ resident.residentName }}
      b-popover(:target="'day8pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 15)") {{ resident.residentName }}
    // セル：9日
    template(#cell(day9am)="row")
      .residents(:id="'day9am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 16)") {{ resident.residentName }}
      b-popover(:target="'day9am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 16)") {{ resident.residentName }}
    template(#cell(day9pm)="row")
      .residents(:id="'day9pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 17)") {{ resident.residentName }}
      b-popover(:target="'day9pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 17)") {{ resident.residentName }}
    // セル：10日
    template(#cell(day10am)="row")
      .residents(:id="'day10am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 18)") {{ resident.residentName }}
      b-popover(:target="'day10am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 18)") {{ resident.residentName }}
    template(#cell(day10pm)="row")
      .residents(:id="'day10pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 19)") {{ resident.residentName }}
      b-popover(:target="'day10pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 19)") {{ resident.residentName }}
    // セル：11日
    template(#cell(day11am)="row")
      .residents(:id="'day11am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 20)") {{ resident.residentName }}
      b-popover(:target="'day11am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 20)") {{ resident.residentName }}
    template(#cell(day11pm)="row")
      .residents(:id="'day11pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 21)") {{ resident.residentName }}
      b-popover(:target="'day11pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 21)") {{ resident.residentName }}
    // セル：12日
    template(#cell(day12am)="row")
      .residents(:id="'day12am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 22)") {{ resident.residentName }}
      b-popover(:target="'day12am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 22)") {{ resident.residentName }}
    template(#cell(day12pm)="row")
      .residents(:id="'day12pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 23)") {{ resident.residentName }}
      b-popover(:target="'day12pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 23)") {{ resident.residentName }}
    // セル：13日
    template(#cell(day13am)="row")
      .residents(:id="'day13am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 24)") {{ resident.residentName }}
      b-popover(:target="'day13am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 24)") {{ resident.residentName }}
    template(#cell(day13pm)="row")
      .residents(:id="'day13pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 25)") {{ resident.residentName }}
      b-popover(:target="'day13pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 25)") {{ resident.residentName }}
    // セル：14日
    template(#cell(day14am)="row")
      .residents(:id="'day14am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 26)") {{ resident.residentName }}
      b-popover(:target="'day14am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 26)") {{ resident.residentName }}
    template(#cell(day14pm)="row")
      .residents(:id="'day14pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 27)") {{ resident.residentName }}
      b-popover(:target="'day14pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 27)") {{ resident.residentName }}
    // セル：15日
    template(#cell(day15am)="row")
      .residents(:id="'day15am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 28)") {{ resident.residentName }}
      b-popover(:target="'day15am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 28)") {{ resident.residentName }}
    template(#cell(day15pm)="row")
      .residents(:id="'day15pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 29)") {{ resident.residentName }}
      b-popover(:target="'day15pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 29)") {{ resident.residentName }}
    // セル：16日
    template(#cell(day16am)="row")
      .residents(:id="'day16am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 30)") {{ resident.residentName }}
      b-popover(:target="'day16am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 30)") {{ resident.residentName }}
    template(#cell(day16pm)="row")
      .residents(:id="'day16pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 31)") {{ resident.residentName }}
      b-popover(:target="'day16pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 31)") {{ resident.residentName }}
    // セル：17日
    template(#cell(day17am)="row")
      .residents(:id="'day17am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 32)") {{ resident.residentName }}
      b-popover(:target="'day17am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 32)") {{ resident.residentName }}
    template(#cell(day17pm)="row")
      .residents(:id="'day17pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 33)") {{ resident.residentName }}
      b-popover(:target="'day17pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 33)") {{ resident.residentName }}
    // セル：18日
    template(#cell(day18am)="row")
      .residents(:id="'day18am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 34)") {{ resident.residentName }}
      b-popover(:target="'day18am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 34)") {{ resident.residentName }}
    template(#cell(day18pm)="row")
      .residents(:id="'day18pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 35)") {{ resident.residentName }}
      b-popover(:target="'day18pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 35)") {{ resident.residentName }}
    // セル：19日
    template(#cell(day19am)="row")
      .residents(:id="'day19am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 36)") {{ resident.residentName }}
      b-popover(:target="'day19am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 36)") {{ resident.residentName }}
    template(#cell(day19pm)="row")
      .residents(:id="'day19pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 37)") {{ resident.residentName }}
      b-popover(:target="'day19pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 37)") {{ resident.residentName }}
    // セル：20日
    template(#cell(day20am)="row")
      .residents(:id="'day20am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 38)") {{ resident.residentName }}
      b-popover(:target="'day20am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 38)") {{ resident.residentName }}
    template(#cell(day20pm)="row")
      .residents(:id="'day20pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 39)") {{ resident.residentName }}
      b-popover(:target="'day20pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 39)") {{ resident.residentName }}
    // セル：21日
    template(#cell(day21am)="row")
      .residents(:id="'day21am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 40)") {{ resident.residentName }}
      b-popover(:target="'day21am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 40)") {{ resident.residentName }}
    template(#cell(day21pm)="row")
      .residents(:id="'day21pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 41)") {{ resident.residentName }}
      b-popover(:target="'day21pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 41)") {{ resident.residentName }}
    // セル：22日
    template(#cell(day22am)="row")
      .residents(:id="'day22am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 42)") {{ resident.residentName }}
      b-popover(:target="'day22am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 42)") {{ resident.residentName }}
    template(#cell(day22pm)="row")
      .residents(:id="'day22pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 43)") {{ resident.residentName }}
      b-popover(:target="'day22pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 43)") {{ resident.residentName }}
    // セル：23日
    template(#cell(day23am)="row")
      .residents(:id="'day23am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 44)") {{ resident.residentName }}
      b-popover(:target="'day23am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 44)") {{ resident.residentName }}
    template(#cell(day23pm)="row")
      .residents(:id="'day23pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 45)") {{ resident.residentName }}
      b-popover(:target="'day23pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 45)") {{ resident.residentName }}
    // セル：24日
    template(#cell(day24am)="row")
      .residents(:id="'day24am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 46)") {{ resident.residentName }}
      b-popover(:target="'day24am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 46)") {{ resident.residentName }}
    template(#cell(day24pm)="row")
      .residents(:id="'day24pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 47)") {{ resident.residentName }}
      b-popover(:target="'day24pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 47)") {{ resident.residentName }}
    // セル：25日
    template(#cell(day25am)="row")
      .residents(:id="'day25am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 48)") {{ resident.residentName }}
      b-popover(:target="'day25am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 48)") {{ resident.residentName }}
    template(#cell(day25pm)="row")
      .residents(:id="'day25pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 49)") {{ resident.residentName }}
      b-popover(:target="'day25pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 49)") {{ resident.residentName }}
    // セル：26日
    template(#cell(day26am)="row")
      .residents(:id="'day26am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 50)") {{ resident.residentName }}
      b-popover(:target="'day26am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 50)") {{ resident.residentName }}
    template(#cell(day26pm)="row")
      .residents(:id="'day26pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 51)") {{ resident.residentName }}
      b-popover(:target="'day26pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 51)") {{ resident.residentName }}
    // セル：27日
    template(#cell(day27am)="row")
      .residents(:id="'day27am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 52)") {{ resident.residentName }}
      b-popover(:target="'day27am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 52)") {{ resident.residentName }}
    template(#cell(day27pm)="row")
      .residents(:id="'day27pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 53)") {{ resident.residentName }}
      b-popover(:target="'day27pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 53)") {{ resident.residentName }}
    // セル：28日
    template(#cell(day28am)="row")
      .residents(:id="'day28am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 54)") {{ resident.residentName }}
      b-popover(:target="'day28am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 54)") {{ resident.residentName }}
    template(#cell(day28pm)="row")
      .residents(:id="'day28pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 55)") {{ resident.residentName }}
      b-popover(:target="'day28pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 55)") {{ resident.residentName }}
    // セル：29日
    template(#cell(day29am)="row")
      .residents(:id="'day29am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 56)") {{ resident.residentName }}
      b-popover(:target="'day29am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 56)") {{ resident.residentName }}
    template(#cell(day29pm)="row")
      .residents(:id="'day29pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 57)") {{ resident.residentName }}
      b-popover(:target="'day29pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 57)") {{ resident.residentName }}
    // セル：30日
    template(#cell(day30am)="row")
      .residents(:id="'day30am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 58)") {{ resident.residentName }}
      b-popover(:target="'day30am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 58)") {{ resident.residentName }}
    template(#cell(day30pm)="row")
      .residents(:id="'day30pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 59)") {{ resident.residentName }}
      b-popover(:target="'day30pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 59)") {{ resident.residentName }}
    // セル：31日
    template(#cell(day31am)="row")
      .residents(:id="'day31am' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 60)") {{ resident.residentName }}
      b-popover(:target="'day31am' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 60)") {{ resident.residentName }}
    template(#cell(day31pm)="row")
      .residents(:id="'day31pm' + row.item.name")
        .resident.text(v-for="resident in getResidents(row.item, 61)") {{ resident.residentName }}
      b-popover(:target="'day31pm' + row.item.name" triggers="hover")
        .resident-name(v-for="resident in getResidents(row.item, 61)") {{ resident.residentName }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { RoomSchedulesGetModel } from "@/commons/services/RoomsSchedules";
import { RoomType } from "@/commons/services/Rooms";

/**
 * ### 空床情報テーブルコンポーネント
 */
@Component({})
export default class RoomsSchedulesTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<RoomsSchedulesTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<RoomsSchedulesTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: any;
  /** フィルター対象カラム */
  @Prop({ required: true })
  filterFields!: string[];
  /** 使用種別 */
  @Prop({ required: true })
  useType!: number;

  get _value(): Array<RoomsSchedulesTableItem> {
    return this.value;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: RoomsSchedulesTableItem): boolean {
    if (row.residentGroupId == this.filter) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### 日付列情報を返す
   *
   * - 部屋名、種別（人数）を切り取る
   * - 切り取り後のデータは「日付AMorPM」になっているので、日付単位に直して（1つにまとめて）返す
   */
  public getDayFields(data: { columns: number; fields: Array<RoomsSchedulesTableField> }): Array<RoomsSchedulesTableField> {
    const slicedFields: Array<RoomsSchedulesTableField> = data.fields.slice(2);

    let dayFields: Array<RoomsSchedulesTableField> = [];
    for (let i = 0; i < slicedFields.length; i = i + 2) {
      dayFields.push(slicedFields[i]);
    }

    return dayFields;
  }

  /**
   * ### 部屋名、種別（人数）を切り取った日付だけのfieldsを返す
   */
  public getDays(data: { columns: number; fields: Array<RoomsSchedulesTableField> }): Array<RoomsSchedulesTableField> {
    const slicedFields: Array<RoomsSchedulesTableField> = data.fields.slice(2);
    return slicedFields;
  }

  /**
   * ### 部屋種別に対応した文字列を返す
   */
  public getRoomTypeName(item: RoomsSchedulesTableItem): string {
    switch (item.roomType) {
      case RoomType.SINGLE: {
        return "個室";
      }
      case RoomType.DOUBLE: {
        return "2人部屋（夫婦部屋）";
      }
      case RoomType.MULTI_MEN: {
        return "多床室（男性）";
      }
      case RoomType.MULTI_WOMEN: {
        return "多床室（女性）";
      }
      default: {
        return "";
      }
    }
  }

  /**
   * ### 人数を返す
   *
   * - 多床室以外は人数は固定なので空文字を返す
   * - 多床室の場合は人数を返す
   */
  public getCapacity(item: RoomsSchedulesTableItem): string {
    switch (item.roomType) {
      case RoomType.SINGLE:
      case RoomType.DOUBLE: {
        return "";
      }
      case RoomType.MULTI_MEN:
      case RoomType.MULTI_WOMEN: {
        return `（${item.capacity}人）`;
      }
      default: {
        return "";
      }
    }
  }

  /**
   * ### 曜日のCSSクラスを返す
   */
  public getWeekClass(date: RoomsSchedulesTableField): string {
    if (date.holidayName) {
      return "holiday";
    }
    switch (date.week) {
      case "日": {
        return "sunday";
      }
      case "土": {
        return "saturday";
      }
      default: {
        return "";
      }
    }
  }

  /**
   * ### 対象インデックスの利用者リストが存在するかチェックすることで安全に取得する
   */
  public getResidents(item: RoomsSchedulesTableItem, index: number): Array<{ residentId: number; residentName: string }> {
    if (item && item.schedules && item.schedules[index] && item.schedules[index].residents) {
      return item.schedules[index].residents;
    }
    return [];
  }
}

/** テーブルの列名の情報 */
export interface RoomsSchedulesTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
  datetime?: string;
  week?: string;
  holidayName?: string;
}

/** テーブルの1行あたりの情報 */
export interface RoomsSchedulesTableItem extends RoomSchedulesGetModel {
  _cellVariants: any;
}
</script>
